import * as React from 'react';
import * as propTypes from 'prop-types';

interface Props {
    styles?: string;
    children?: any;
}

const removePollutingStyles = (styles: string): string => {
    if (window.self === window.top) {
        return styles
            .replace(/body,/g, '')
            .replace(/label,/g, '')
            .replace(/button\[type=('|")submit('|")\]\s*?\{.*?\}\n?/gs, '') //button type submit overwrites
            .replace(/a:link,\s+a:visited,\s+a:hover,\s+a:active\s*?\{.*?\}\n?/gs, '') //links overwrites
            .replace(/h1\s*?\{.*?\}\n?/gs, ''); //h1 overwrites

    }
    return styles;
};

const CustomCssWrapperComponent: React.SFC<Props> = props => (
    <div>
        {props.styles ?
            (<style>
                {removePollutingStyles(props.styles)}
            </style>)
        : null}

        {props.children ?
            props.children
        : null}
    </div>
);

CustomCssWrapperComponent.propTypes = {
    styles: propTypes.string,
    children: propTypes.any,
};

CustomCssWrapperComponent.defaultProps = {
    styles: '',
    children: '',
};

export { CustomCssWrapperComponent };
